module.exports = "https://sf6-scmcdn2-tos.pstatp.com/motor/pc/_next/static/images/6-87dd555fb969eae8ac52c492ae5a09c7.png";